import { onboardingQueryKeys as e } from "../onboarding/useOnboardingQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { usersApi as r } from "@maat/api-main";
import { authQueryKeys as i } from "@maat/store-auth";
//#region src/profile/useUpdateProfileMutation.ts
var a = () => {
	let a = n();
	return t({
		mutationFn: r.updateProfile,
		onSuccess: () => {
			a.invalidateQueries({ queryKey: i.state() }), a.invalidateQueries({ queryKey: i.me() }), a.invalidateQueries({ queryKey: e.status() });
		}
	});
};
//#endregion
export { a as useUpdateProfileMutation };
